module.exports = "\n<div #mysea id=\"openseadragon1\" style=\"width: 800px; height: 600px;\"></div>\n\n<button (click)=\"back()\" >Pagina precedente</button>\n<button  (click)=\"next()\"  >Pagina successiva</button>\n"


//////////////////
// WEBPACK FOOTER
// /Users/paspao/workspaceForMaven/libri/libriweb/src/app/dettaglio/dettaglio-immagine-battezzato.component.html
// module id = ../../../../../src/app/dettaglio/dettaglio-immagine-battezzato.component.html
// module chunks = main